import { apiClient } from "./client";
import { setAuthToken, setAuthUser } from "./tokenStorage";

export const loginUser = async (credentials) => {
  const response = await apiClient.post("/auth/login", credentials, {
    includeToken: false
  });

  if (response.token) {
    setAuthToken(response.token);
  }

  if (response.user) {
    setAuthUser(response.user);
  }

  return response;
};

export const logoutUser = () => {
  return apiClient.post("/auth/logout", {});
};

export const forgotPassword = async (email) => {
  return apiClient.post("/auth/forgot-password", { email }, {
    includeToken: false
  });
};

export const verifyResetToken = async (token) => {
  return apiClient.get(`/auth/reset-password/verify/${token}`, {
    includeToken: false
  });
};

export const resetPassword = async (token, password, confirmPassword) => {
  return apiClient.post("/auth/reset-password", { token, password, confirmPassword }, {
    includeToken: false
  });
};
